import React from 'react';
import BasePage from 'components/pages/BasePage/BasePage';
import AccountRegistration from 'components/layouts/Preferences/AccountRegistration/AccountRegistration';
import { connect } from 'react-redux';
import { getAccountRegistrationTableData } from 'state/accountRegistration/AccountRegistrationSelectors';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import {
  canViewBeneficiaries,
  hasOnlyViewOnly,
  isMobile,
  isSalesforceRepEnabled
} from 'state/view/ViewSelectors';
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';
import { addLRNEnabled } from 'services/FeatureFlags';
import {legalReferenceNumbers} from 'services/Content';
import { mapProductTypeToiiFooterBoolean } from 'state/account/AccountSelectors';
import { hasAppLoaded } from 'state/analytics/analyticsSelectors';

const AccountRegistrationPage = ({
  requestStatus,
  tableData,
  canViewBeneficiaries,
  hasOnlyViewOnly,
  isMobileApp,
  footerProductTypes,
  appLoaded,
  isSalesforceRepEnabled
}) => {
  return (
    <BasePage
      title={'Account Registration'}
      titleSubText={
        'Review your account registration information and access the proper forms to update if needed.'
      }
      backLink={'/profile'}
      backLinkText={'Back to Profile & Settings'}
      showFooter={true}
      isLoading={requestStatus.accounts !== REQUEST_STATES.received}
      isError={requestStatus.accounts === REQUEST_STATES.error}
      pageName={'Account Registration'}
      isMobileApp={isMobileApp}
      footerProductTypes={footerProductTypes}
      appLoaded={appLoaded}
      isSalesforceRepEnabled={isSalesforceRepEnabled}
      className={'account-registration-page-container'}>
      <AccountRegistration
        tableData={tableData}
        canViewBeneficiaries={canViewBeneficiaries}
        hasOnlyViewOnly={hasOnlyViewOnly}
      />
      {addLRNEnabled() && (
        <div className="account-registration-lrn-page-footer">
          <LegalReferenceNumber
            providedLegalNumber={legalReferenceNumbers.PROFILE_PAGE_LRN}
          />
        </div>
      )}
    </BasePage>
  );
};

const mapStateToProps = (state) => {
  return {
    tableData: getAccountRegistrationTableData(state),
    requestStatus: getRequestStatus(state),
    canViewBeneficiaries: canViewBeneficiaries(state),
    hasOnlyViewOnly: hasOnlyViewOnly(state),
    isMobileApp: isMobile(state),
    footerProductTypes: mapProductTypeToiiFooterBoolean(state),
    appLoaded: hasAppLoaded(state),
    isSalesforceRepEnabled: isSalesforceRepEnabled(state)
  };
};
export default connect(mapStateToProps)(AccountRegistrationPage);
